import { ThemeConfig } from 'antd'
import { colors } from './colors'

export const themeConfig: ThemeConfig = {
  token: {
    colorPrimary: colors.primary,
    colorLink: colors.primaryLight
  }
}
